'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function BlockHidden(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M960 480h-64V160a32 32 0 0 0-32-32H160a32 32 0 0 0-32 32v704a32 32 0 0 0 32 32h192v64H127.712C92.512 960 64 931.2 64 896.288V127.68C64 92.512 92.8 64 127.712 64H896.32C931.488 64 960 92.8 960 127.712V480zM288 160h64v64H288V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m128 0h64v64h-64V160z m0 128h64v64h-64V288zM160 288h64v64H160V288z m0 128h64v64H160v-64z m0 128h64v64H160v-64z m0 128h64v64H160v-64zM160 160h64v64H160V160z m0 640h64v64H160v-64z' }),
    React.createElement('path', { d: 'M559.392 933.44l98.464-98.432a100.32 100.32 0 0 0 113.12-113.12l111.424-111.424a376.416 376.416 0 0 1 65.6 104.416c5.344 13.76 5.344 28.48 0 42.24-19.52 46.624-95.104 198.88-276 198.88-43.392 0-80.704-8.672-112.608-22.528z m-97.92-71.744c-36.416-40.544-56.64-83.424-65.44-104.576a57.472 57.472 0 0 1 0-42.24c19.456-46.624 94.24-198.88 275.968-198.88 43.296 0 80.576 8.736 112.512 22.656l-98.368 98.336a100.32 100.32 0 0 0-113.12 113.12l-111.552 111.584z m394.368-309.536a20 20 0 0 1 0 28.288L516.48 919.84a20 20 0 1 1-28.288-28.288L827.52 552.16a20 20 0 0 1 28.288 0z' })
  );
}
BlockHidden.displayName = 'BlockHidden';

module.exports = BlockHidden;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/blockHidden.js
// module id = 156
// module chunks = 0